var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTutorialVideo = function SvgTutorialVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "210 0 540 540",
    strokeWidth: 40,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.543 270v0c0-131.696 106.761-238.457 238.457-238.457v0C622.749 33.453 716.602 146.987 718.457 270v0c0 131.696-106.761 238.457-238.457 238.457v0c-131.696 0-238.457-106.761-238.457-238.457Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.92 377.453v-212.54c91.556 52.049 112.436 64.766 187.636 107.011-58.022 32.985-107.471 59.957-187.635 105.53z"
  })));
};
export default SvgTutorialVideo;